export default __webpack_public_path__ + "static/media/stereo_11.6cde4ba4.gif";